import { Navigate } from "react-router-dom"
import { useCurrentUser } from "@/lib/useCurrentUser"

interface AdminGateProps {
  children: React.ReactNode
}

/**
 * UI-only admin gate component.
 * Waits for current-user resolution before deciding whether to render
 * children or redirect to /not-authorized.
 */
export function AdminGate({ children }: AdminGateProps) {
  const { loaded, isAdmin } = useCurrentUser()

  if (!loaded) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="mt-4 text-sm text-muted-foreground">Checking access...</p>
        </div>
      </div>
    )
  }

  if (!isAdmin) {
    return <Navigate to="/not-authorized" replace />
  }

  return <>{children}</>
}
